import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getFields, getList, getFieldsDataView } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput'
import { Add, ApartmentOutlined, BusinessOutlined, Delete, DomainAddOutlined, Edit, Label } from '@mui/icons-material'
import { dataTypeOptions } from '../../util';
import MultipleSelectChip from '../../components/common/MultipleSelectChip'
import { Link } from 'react-router-dom';
import TuneIcon from '@mui/icons-material/Tune';
import PhonelinkOffIcon from '@mui/icons-material/PhonelinkOff';
import CustomDataGrid from '../../components/CustomDataGrid'

const DataView = () => {
    const [ showModal, setShowModal ] = useState(false)
    const [ selectedDataset, setSelectedDataset ] = useState(null);
    const [ records, setRecords ] = useState([]);
    const [ domains, setDomains ] = useState([]);
    const [ institutions, setInstitutions ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [ processing, setProcessing ] = useState(false)
    const [ mapConsumers, setMapConsumers ] = useState(false);
    const [ viewModel, setViewModel ] = useState(false);
    const [ mapping, setMapping ] = useState(false);
    const [ selectedView, setSelectedView ] = useState({});
    const [ datasets, setDatasets ] = useState([]);
    const [ deleteModal, setDeleteModal ] = useState(false);
    const [ isDeleting, setIsDeleting] = useState(false);


    const initialFilter = {
        index: "",
        values: [],
        columns: []
    };


    const [ filterValue, setFilterValue ] = useState(initialFilter);
    

    const defaultField = {
        "fieldName": "",
        "fieldMaxLenght": 0,
        "dataType": "",
        "friendlyName": ""
    };

    const defaultView = {
        // "id": "", 
        // "target": "dataview", 
        // "operationType": "add", 
        // "record_Data": { 
        "dataSetID": '', 
        "dataViewName": "", 
        "script": "", 
        "type": "", 
        "joins": [ 
            // { 
            //     "tableName": "key_indicators", 
            //     "tableAlias": "key", 
            //     "joinField": "code", 
            //     "selectedColumns": "domain,description,indent", 
            //     "joinTable": "bpm_series", 
            //     "joinTableField": "code", 
            //     "filters": [ 
            //         { "report": null, "columnName": "category", "operator": "=", "columnValue": "bpm6", "displayName": null, "isIncluded": false, "id": 0 } 
            //     ], 
            //     "id": 0 
            // } 
        ]
    };

    const defaultJoin = {
        "tableName": "", 
        "tableAlias": "", 
        "selectedColumns": "", 

        "joinField": "",
        "joinTable": "", 
        "joinTableField": "", 

        "filters": [ 
            // { 
            //     "columnName": "", 
            //     "operator": "", 
            //     "columnValue": "",
            //     // "report": null, 
            //     // "displayName": null, 
            //     // "isIncluded": false, 
            //     // "id": 0
            // } 
        ],
    };

    const defaultFilter = {
        columnName: "",
        operator: "",
        columnValue: ""
    };

    const fetchFields = async (dataview) => {
        // try {
        //     const resp = await getFieldsDataView(dataview.id);
        //     console.log(resp)
        //     if(resp?.responseCode === "00") {
        //         setSelectedView({ ...dataset, fields: resp?.listing || [] })
        //         setShowModal(true)
        //     } else {
        //         enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
        //     }
        // }
        // catch(err) {

        // }

        const select = records?.find(({ id }) => String(id) == String(dataview.id));

        select?.joins?.forEach((next, index) => {
            let field = datasets?.find(({ dB_Table }) => dB_Table == next.tableName);
            let fieldTwo = datasets?.find(({ dB_Table }) => dB_Table == next.joinTable);
            
            select.joins[index].tableFields = field?.fields;
            select.joins[index].joinTableFields = fieldTwo?.fields;
        });
       
        setSelectedView(select);
        setShowModal(true);
    }

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', flex: 0.1, sortable: false,
            renderCell: (params) => (
                <p
                    style={{ margin: 'auto' }}
                >
                    {params?.row?.sn}
                </p>
            )
        },
        
        {
            field: 'actions', headerName: 'Actions', flex: 0.12, sortable: false,
            renderCell: (params) => (
                <div className='action-icons' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%', padding: '0 0.5rem' }}>
                    <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Edit DataView' className='p-0 m-0'
                        onClick={() => {
                            fetchFields(params?.row);
                        }}
                    >
                        <Edit />
                    </IconButton>

                    {/* <IconButton
                        size='small'
                        color="primary"
                        variant="outlined" title='Set Consumers' className='p-0 m-0'
                        onClick={() => {
                            setSelectedDataset(params?.row);
                            setMapConsumers(true)
                        }}
                    >
                        <BusinessOutlined />
                    </IconButton> */}
                    <IconButton
                        size='small'
                        color="error"
                        variant="outlined" title='Delete DataView' className='p-0 m-0'
                        onClick={() => {
                            setSelectedView(params?.row);
                            setDeleteModal(true)
                        }}
                    >
                        <PhonelinkOffIcon />
                    </IconButton>
                </div>
            )
        },
        { field: 'dataViewName', headerName: 'Data View', flex: 1 },
    ];

    const handleChange = (event, value) => {
        let newConsumers = [ ...selectedDataset?.consumers ] || [];
        if(value) {
            if(event.target.name == "001") {
                newConsumers = [ ...institutions?.map(({ id }) => ({ id }) ) ]
            } else {
                newConsumers.push({ id: event.target.name });
            }
        } else {
            if(event.target.name == "001") {
                newConsumers = []
            } else {
                newConsumers = newConsumers.filter(({ id }) => (id != event.target.name) && (id != "001"))
            }
            
        }
        setSelectedDataset({ ...selectedDataset, consumers: newConsumers })
    }

    const handleFieldChange = (name, value, key) => {
        let newDocs = [ ...selectedDataset.fields ]
        let doc = newDocs[key];
        const id = name.split(`${key}-`)[1]
        doc[id] = value;
        newDocs[key] = doc            
        setSelectedDataset({...selectedDataset, fields: newDocs })
    }

    const hasPrivilege = (id) => {
        return (selectedDataset?.consumers?.map(x => String(x?.id))?.indexOf(String(id)) >= 0) ? true : false
    }

    const handleMapping = async () => {
        try {
            setMapping(true)
            const resp = await AddorUpdateRecord("dataset", "update", selectedDataset);
            if(resp?.responseCode === "00") {
                init();
                setMapping(false);
                setSelectedDataset(null)
                setMapConsumers(false)
                enqueueSnackbar('Mapping successful')
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' })
        }
        finally {
            setMapping(false)
        }
    };

    const deleteTable = (key) => {
        setSelectedView({
            ...selectedView,
            joins: [
                ...selectedView.joins?.filter((d, index) => index != key )
            ]
        })
    };

    const deleteFilter = (key, pos) => {
        let obj = selectedView
        obj.joins[pos].filters = obj.joins[pos].filters.filter((next, index) => index != key)
        setFilterValue({
            ...filterValue,
            values: [ ...filterValue.values?.filter((next, index) => index != key) ]
        })
        setSelectedView({ ...obj })
    } 

    const listOperators = [
        { name: "Equal To", value: "=" },
        { name: "Not Equal To", value: "!=" },
        { name: "Contains", value: "like" },
        { name: "Not Contain", value: "not like" },
        { name: "Greater Than", value: ">" },
        { name: "Less Than", value: "<" },
        { name: "Greater Than or Equal To", value: ">=" },
        { name: "Less Than or Equal To", value: "<=" }
    ]

    const submitFilters = (values) => {
        console.log("Submit");
    }
    const handleJoinChange = (name, value, key, isPlanText = false) => {
        
        let newJoins = [ ...selectedView.joins ];
        let join = newJoins[key];
        let id = "";
        isPlanText ? id = name : id = name.split(`${key}-`)[1];
        join[id] = value;
        newJoins[key] = join;

        setSelectedView({
            ...selectedView,
            joins: newJoins
        })
    };

    const listValues = (args) => {
        if(args)
        return args.map((next) => (next.fieldName))
    };

    const handleFilterJoin = (name, value, key, index) => {
        let nextFilter = [ ...selectedView.joins[index].filters ];
        
        let filter = nextFilter[key];
        let id = name.split(`${key}-`)[1];
        filter[id] = value;
        nextFilter[key] = filter;
        
        let dataViewObject = selectedView
        dataViewObject.joins[index].filters = nextFilter;
        console.log(dataViewObject)
        setSelectedView({ ...dataViewObject })
    };


    const init = async () => {
        try {
            setProcessing(true)
            const resp = await getList("dataset_views");
            const response = await getList("datasets");

            if(resp?.responseCode === "00") {
                setRecords(resp?.listing || [])
                setDatasets(response?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const getDomains = async () => {
        try {
            setProcessing(true)
            const resp = await getList("domains");
            if(resp?.responseCode === "00") {
                setDomains(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const createOrUpdateDataset = async (values, { resetForm }) => {
        let payload = selectedView;
        //console.log("Value of updating form object in submit: ", selectedView);
        payload.joins.forEach((next) => {
            delete next.joinTableFields
            delete next.tableFields
        });
        try {
            const resp = await AddorUpdateRecord("dataview", selectedView?.id ? "update" : 'add', payload);
            if(resp?.responseCode === "00") {
                init();
                setSelectedView({})
                setShowModal(false)
                enqueueSnackbar('Action performed successfully')
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const deleteDataView = async () => {
        try {
            setIsDeleting(true);

            const res = await AddorUpdateRecord("dataview", "delete", selectedView);

            if(res.responseCode === "00") {
                init();
                setSelectedDataset(null);
                setDeleteModal(false);
                enqueueSnackbar('Dataview deleted successfully', { variant: 'success' });
            }
            else {
                enqueueSnackbar(res?.message ?? res?.responseMessage ?? 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message ?? err?.responseMessage ?? 'An error occurred', { variant: 'error' })
        }
        finally {
            setIsDeleting(false);
        }
    }

    useEffect(() => {
        init()
        getDomains()
    }, [])

    return (
        <PageContainer pageTitle='Data Views' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">All</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Data Views</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 text-align-right'>
                            <Link to={'/internal/data-views/create'}>
                                <Button variant="contained">Create View</Button>
                            </Link>
                        </div>
                        <div className='col-12 mt-4'>
                            <div style={{ height: 600, width: '100%', textAlign: 'center' }}>
                                <CustomDataGrid 
                                    columns={columns}
                                    rows={records}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={showModal} maxWidth="lg">
                <Formik enableReinitialize initialValues={selectedView} onSubmit={createOrUpdateDataset}>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent className='pl-4 pr-4'>
                                <h3 className='text-bold mt-05' >{values?.id ? 'Update' : 'Create'} Data View</h3>
                                <Divider className="mt-05 mb-2" />
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                        <SelectInput id="dataSetID" required label="Dataset" field="id" fieldDisplay='dataSetName' options={datasets} 
                                            customChange={(name, value) => {
                                                const table = datasets?.find(({ id }) => id == value);
                                                setSelectedView({
                                                    ...selectedView,
                                                    dataSetID: table?.id,
                                                    // joins: [
                                                    //     {
                                                    //         ...defaultJoin,
                                                    //         tableName: table.dB_Table || '',
                                                    //         tableAlias: table?.dataSetName || '',
                                                    //         fields: table?.fields || []
                                                    //     }
                                                    // ]
                                                })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <SelectInput id="type" required label="Dataview Type" field="code" fieldDisplay='label' options={[
                                            { code: 'dbview', label: 'Db View' },
                                            { code: 'stored_query', label: 'Stored Query' },
                                        ]} 
                                        customChange={(name, value) => {
                                            setSelectedView({...selectedView, type: value})
                                        }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="dataViewName" required label="Data View Name"
                                            customChange={(name, value) => {
                                                setSelectedView({ ...selectedView, dataViewName: value })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput id="script" label="Script" multiline minRows={2} placeholder="Enter script (optional)"
                                            customChange={(name, value) => {
                                                setSelectedView({ ...selectedView, script: value })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                        <Button variant="outlined" className='mt-1' onClick={() => {
                                                setSelectedView({
                                                    ...selectedView, 
                                                    joins: [ ...selectedView.joins, defaultJoin ]
                                                })
                                            }} startIcon={<Add />}
                                        >Add Table</Button>
                                    </Grid>

                                    {/* 
                                    
                                        "tableName": "key_indicators", 
                                        "tableAlias": "key", 
                                        "selectedColumns": "domain,description,indent", 

                                        "joinField": "code",
                                        "joinTable": "bpm_series", 
                                        "joinTableField": "code", 

                                        "filters": [ 
                                            { 
                                                "columnName": "category", 
                                                "operator": "=", 
                                                "columnValue": "bpm6",
                                                
                                                "report": null, 
                                                "displayName": null, 
                                                "isIncluded": false, 
                                                "id": 0
                                            } 
                                        ], 
                                    
                                    */}
                                    <Grid item xs={12} container spacing={3}>
                                        {
                                            values.joins?.map((table, key) => (
                                                <Grid key={key} container alignItems={'center'} item xs={12} spacing={2}>
                                                    <Grid item lg={12} xs={12}>
                                                        {
                                                            key > 0 &&
                                                            <IconButton color="error" size={'large'} title="Delete"
                                                                onClick={() => deleteTable(key)}
                                                            >
                                                                <Delete />
                                                            </IconButton>
                                                        }
                                                    </Grid>
                                                    <Grid item xs={12} lg={3} md={4}>
                                                        <SelectInput capitalizeLabel={false} value={table.tableName
                                                        } options={datasets} field="id" fieldDisplay='dB_Table' id={`${key}-tableName`} label="Table Name" floatingLabel
                                                            customChange={(name, value) => {
                                                                const tab = datasets?.find(({ id }) => String(id) == String(value));
                                                                handleJoinChange(name, tab.dB_Table, key);
                                                                if(tab)
                                                                handleJoinChange("tableFields", tab.fields, key, true);
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} lg={3} md={4}>
                                                        <MultipleSelectChip customValue={table?.selectedColumns.length > 0 ? table?.selectedColumns.split(',') : []} entries={listValues(table?.tableFields) || []} label="Selected Columns" id={`${key}-selectedColumns`} 
                                                        customChange={(name, value) => {
                                                            handleJoinChange(name, value.join(","), key)
                                                        }}
                                                        />   
                                                    </Grid>
                                                    <Grid item xs={12} lg={3} md={4}>
                                                        <SelectInput capitalizeLabel={false} value={table.joinField
                                                        } options={table?.tableFields} field="id" fieldDisplay='fieldName' id={`${key}-joinField`} label="Join Field" floatingLabel
                                                            customChange={(name, value) => {
                                                                const tab = table?.tableFields.find(({ id }) => String(id) == String(value));
                                                                if(tab)
                                                                handleJoinChange(name, tab.fieldName, key);
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} lg={3} md={4}>
                                                        <SelectInput options={datasets}  capitalizeLabel={false} value={table.joinTable} field="id" fieldDisplay='dB_Table' id={`${key}-joinTable`} label="Table Join" floatingLabel
                                                            customChange={(name, value) => {
                                                                const tab = datasets?.find(({ id }) => String(id )== String(value));
                                                                handleJoinChange(name, tab.dB_Table, key)
                                                                handleJoinChange("joinTableFields", tab.fields, key, true);
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} lg={2.5} md={4}>
                                                        <SelectInput options={table?.joinTableFields || []} field="id" value={table.joinTableField} fieldDisplay='fieldName' id={`${key}-joinTableField`} label="Table Join Column" floatingLabel
                                                            customChange={(name, value) => {
                                                                const tab = table?.joinTableFields.find(({ id }) => String(id) == String(value));
                                                                handleJoinChange(name, tab.fieldName,  key)
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} lg={2.5} md={4}>
                                                        <Button className='mt-1' variant='contained' startIcon={<TuneIcon />}
                                                            onClick={() => {
                                                                table?.filters.length == 0 
                                                                ?
                                                                setFilterValue({ index: key, values: [ defaultFilter ], columns: listValues(table?.tableFields) || [] })
                                                                :
                                                                setFilterValue({ index: key, values: table?.filters, columns: listValues(table?.tableFields) })
                                                                
                                                                if(selectedView.joins[key].filters.length == 0){
                                                                    let newFilter = selectedView
                                                                    newFilter.joins[key].filters.push(defaultFilter)
                                                                    setSelectedView({
                                                                        ...newFilter
                                                                    });
                                                                }
                                                                
                                                                setViewModel(true);
                                                            }}
                                                        >Filters</Button>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Divider />
                                                    </Grid>
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setSelectedDataset(null) }}} color="secondary" variant="contained" >Cancel</Button>
                                <Button type='submit' variant="contained" disabled={isSubmitting}>
                                    {
                                        isSubmitting ?
                                        <CircularProgress size={15} color="inherit" />
                                        :
                                        values?.id ? 'Update Data View' : 'Add Data View'
                                    }
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
            <Dialog open={viewModel} maxWidth="md">
                <DialogTitle><h3>Filters</h3></DialogTitle>
                <Formik
                    enableReinitialize
                    initialValues={{...filterValue}}
                    onSubmit={submitFilters}
                >
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Button variant='outlined' className='mb-1' startIcon={<Add />}
                                            onClick={() => {
                                                setFilterValue({ ...filterValue, values: [...filterValue.values, defaultFilter ] })
                                                let newFilter = selectedView
                                                newFilter.joins[filterValue.index].filters.push(defaultFilter)
                                                setSelectedView({
                                                    ...newFilter
                                                });
                                            }}
                                        >Add Filter</Button>
                                    </Grid>
                                    {
                                        values.values?.map((next, key) => (
                                            <Grid key={key} container alignItems={'center'} item xs={12} spacing={2}>
                                                <Grid item lg={12} xs={12}>
                                                    {
                                                        key > 0 &&
                                                        <IconButton color="error" size={'large'} title="Delete"
                                                            onClick={() => deleteFilter(key, filterValue.index)}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    }
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <MultipleSelectChip customValue={next?.columnName.length > 0 ? next.columnName.split(',') : []}  entries={filterValue.columns} label="Columns Names" id={`${key}-columnName`}
                                                        customChange={(name, value) => {
                                                            handleFilterJoin(name, value.join(","), key, filterValue.index)
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <SelectInput value={next?.operator?.length > 0 ? listOperators.find(({ value }) => value == next?.operator)?.name : ''} options={listOperators} field="value" fieldDisplay='name' id={`${key}-operator`} label="Operators" floatingLabel
                                                        customChange={(name, value) => {
                                                            handleFilterJoin(name, value, key, filterValue.index)
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <TextInput floatingLabel label="Value" id={`${key}-columnValue`} value={next.columnValue}
                                                        customChange={(name, value) => {
                                                            handleFilterJoin(name, value, key, filterValue.index)
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider />
                                                </Grid>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </DialogContent>
                            <DialogActions className='pr-3 pb-3'>
                                <Button type="submit" variant='contained' onClick={() => setViewModel(false)} >Submit</Button>
                                <Button variant='contained' type='button' color='error' onClick={() => { setViewModel(false)}}>Cancel</Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={deleteModal} maxWidth="lg">
                <DialogContent className='pl-4 pr-4'>
                    <p className='text-bold mt-05' style={{ fontSize: "1.2em" }} >Are you sure you want to <b style={{ color: "red" }}>delete the Data View</b> from the system</p>
                    <Divider className="mt-2" />
                </DialogContent>
                <DialogActions className='pr-3 pb-3'>
                    <Button 
                        disabled={isDeleting} 
                        onClick={() => { 
                            if(!isDeleting) { 
                                setDeleteModal(false); 
                                setSelectedView(null) 
                            }}} 
                        color="secondary" 
                        variant="contained" >
                            Cancel
                        </Button>
                    <Button variant="contained" disabled={isDeleting} onClick={deleteDataView} >
                        {
                            isDeleting ?
                            <CircularProgress size={15} color="inherit" />
                            :
                            'Delete Data View'
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </PageContainer>
    )
}

export default DataView